import { render, staticRenderFns } from "./ShopStatPub.vue?vue&type=template&id=0372418c&scoped=true&"
import script from "./ShopStatPub.vue?vue&type=script&lang=js&"
export * from "./ShopStatPub.vue?vue&type=script&lang=js&"
import style0 from "./ShopStatPub.vue?vue&type=style&index=0&id=0372418c&scoped=true&lang=css&"
import style1 from "./ShopStatPub.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0372418c",
  null
  
)

export default component.exports